import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Modal, notification, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../../i18n";
import router from "../../../../../router";
import store from "../../../../../store";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView,
    watchRulesChildren
} from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { has, have } from "../../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionPdf,
    createRowActionReStatus,
    createRowActionView
} from "../../../../../utils/page";
import { flatWhereGroup } from "../../../../../utils/search";
import { greaterThan, lessThanOrEqualTo, required, requiredWhen, validateError } from "../../../../../utils/validate";
import { openModalForm as openModalFormConfirmAcknowledge } from "./modal/confirm-acknowledge.logic";
import { openModalForm as openModalFormConfirmApprove } from "./modal/confirm-approve.logic";
import { openModalForm as openModalFormConfirmReceive } from "./modal/confirm-receive.logic";
import { callRequestDoc, callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    callRequestDocGenType,
    callUser,
    callUserCompanyMe
} from "../../../storage-location/request/requestor/requestor.section";
import { createForm as createFormRelease } from "../release-result/release-result.logic";
import { createConditionAction, createConditionFormResult, createConditionFormRelease } from "./request.condition";
import { createColumns, createField } from "./request.section";
import { callRequestAll } from "../../../storage-location/request/request-approve.logic";
import { createConditionForm as createConditionFormInform } from "../../../inform/request/request.condition";
import { callAddressType } from "../../../../../components/address/address.logic";
import { formatXml } from "../../../../../utils/util";
import { modalStyleForm } from "../../../../../utils/constant";

const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));
const GenReleaseForm = defineAsyncComponent(() => import("./modal/GenReleaseForm.vue"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReStatus = ({ data }) => store.dispatch(`${actionPrefix}/reStatus`, { data });
export const callReportRelease = ({ data }) => store.dispatch(`${actionPrefix}/reportRelease`, { data });
export const callResultType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "RELEASE_RESULT", value: searchQuery });
export const sendNswOGAInspectionResult = ({ data }) => store.dispatch(`${actionPrefix}/sendNswOGAInspectionResult`, { data });
export const sendNswRelease = ({ data }) => store.dispatch(`${actionPrefix}/sendNswRelease`, { data });
export const generateReleaseDoc = ({ data }) => store.dispatch(`resource/v1/transaction/release/generateReleaseDoc`, { data });

export const onSearch = ({ props, page }) => {
    const { routerPrefix } = props;
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const companyNameThIndex = customWhere.findIndex(d => d.name === "refReleaseTemp.refUserCompany.companyNameTh");
    if (companyNameThIndex !== -1) {
        const companyNameThWhere = customWhere[companyNameThIndex];
        customWhere.splice(
            companyNameThIndex,
            1,
            {
                openBucket: true,
                name: "refReleaseTemp.refUserCompany.companyNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refReleaseTemp.refUserCompany.fullNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            }
        );
    }
    if (routerPrefix === "release-results") {
        // approve
        const statusApproveIndex = customWhere.findIndex(d => d.name === "refStatus.id" && d.operator === "=" && d.value === "8014c53e-097b-4e9e-b760-51e423d2d166")
        const statusWaitApproveIndex = customWhere.findIndex(d => d.name === "refStatus.id" && d.operator === "=" && d.value === "0ccb8bb5-ee22-46af-96f1-6b55ffb23de6")
        const statusCancelIndex = customWhere.findIndex(d => d.name === "refStatus.id" && d.operator === "=" && d.value === "718239f1-b4d1-48be-bb56-63c2ced4e3a0")
        if (statusApproveIndex > -1) {
            customWhere.splice(
                statusApproveIndex,
                1,
                {
                    name: "refReleaseTemp.isApproveResult",
                    type: "Boolean",
                    operator: "=",
                    value: true,
                },
                // {
                //     name: "refStatus.key",
                //     type: "String",
                //     operator: "in",
                //     value: ["waitRelease", "waitApprove", "approve", "cancel"],
                // }
            )
        } else if (statusWaitApproveIndex > -1 || statusCancelIndex > -1) {
            customWhere.splice(
                statusWaitApproveIndex,
                0,
                {
                    name: "refReleaseTemp.isApproveResult",
                    type: "Boolean",
                    operator: "=",
                    value: null,
                },
            )
        }
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then(page => {
            (state.page = { ...page, where, sort })
        })
        .finally(() => setIsLoading(false));
};

export const validate = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    const rulesResult = createRulesResult({ props, data, refs });
    const rulesRelease = ["release-requests", "release-cancels", "releases"].includes(routerPrefix) ? createRulesRelease({ props, data, refs }) : [];
    const rulesProduct = createRulesProduct({ props, data, refs });
    const rulesOpenInspection = createRulesOpenInspection({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesResult))
        .then(() => {
            return data.useForm.validate(Object.keys(rulesRelease));
        })
        .then(() => {
            return data.useForm.validate(Object.keys(rulesProduct));
        })
        .then(() => {
            tabKey = "OpenInspectionInfo";
            return data.useForm.validate(Object.keys(rulesOpenInspection));
        })
        .catch(error => {
            if (tabKey) {
                data.tabKey = "OpenInspectionInfo";
            }
            validateError({ error });
            throw error;
        });
};

export const onClickSave = ({ props, data, refs, formParams, successText }) => {
    const { viewOnly, routerPrefix } = props;
    return validate({ props, data, refs }).then(() => {
        setIsLoadingApp(true);
        return callRequest({ form: { ...data.useForm.modelRef, ...formParams } })
            .finally(() => setIsLoadingApp(false))
            .then(record => {
                if (successText) notification["success"]({ message: successText });
                if (viewOnly) initForm({ props, data, refs });
                else onClickView({ record, routerPrefix });
            });
    });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ id, forLog, prefix = "refReleaseTemp." }) => {
    if (!forLog) {
        return {
            select: [
                "**",
                "refRelease.id",
                "refRelease.approveCode",
                "refRelease.refUserCompany.*",
                "refRelease.refUserCompany.refPersonType.*",
                `${prefix}**`,
                `${prefix}refUserCompany.**`,
                `${prefix}refUser.**`,
                `${prefix}refDepartment.*`,
                `${prefix}refInspection.id`,
                `${prefix}refApproveResultBy.id`,
                `${prefix}refApproveResultBy.username`,
                `${prefix}refInspection.approveCode`,
                `${prefix}refInspection.refRequestDoc.id`,
                `${prefix}refInspection.refRequestDoc.key`,
                `${prefix}refInspection.refRequestDoc.value`,
                `${prefix}refInspection.refSequestrate.id`,
                `${prefix}refInspection.refSequestrate.key`,
                `${prefix}refInspection.refSequestrate.value`,
                `${prefix}refInspection.refInformTemp.*`,
                `${prefix}refInspection.refInformTemp.refRequestDoc.id`,
                `${prefix}refInspection.refInformTemp.refRequestDoc.key`,
                `${prefix}refInspection.refInformTemp.refRequestDoc.value`,
                `${prefix}refInspection.refInformTemp.refOperation.id`,
                `${prefix}refInspection.refInformTemp.refOperation.key`,
                `${prefix}refInspection.refInformTemp.refOperation.value`,
                `${prefix}refInspection.refInformTemp.refUserCompany.id`,
                `${prefix}refInspection.refInformTemp.refTransferDeclaration.id`,
                `${prefix}refInspection.refInformTemp.refTransferDeclaration.declarationNumber`,
                `${prefix}refInspection.refInformTemp.refTransferDeclaration.referenceNumber`,
                `${prefix}refInspection.refInformTemp.refTransferDeclaration.containerNo`,
                `${prefix}refInspection.refInformTemp.refTransferDeclaration.vehicleNo`,
                `${prefix}refInspection.refInformTemp.refExportCheckpoint2.id`,
                `${prefix}refInspection.refInformTemp.refExportCheckpoint2.nameTh`,
                `${prefix}refInspection.refInformTemp.refExportCheckpoint2.fullCode`,
            ],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [
                {
                    name: `${prefix}openInspectionsReal`,
                    asName: `${prefix}openInspections`,
                    select: ["**"],
                    page: 0,
                    size: 1,
                    sort: [{ name: "createDate", type: "DESC" }],
                    children: []
                },{
                    name: `${prefix}officers`,
                    select: ["*", "refUser.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: `${prefix}refInspection.products`,
                    select: ["*", "refInformProduct.id"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "statuses",
                    asName: "lastStatus.draft",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "draft" }],
                    sort: [{ name: "createDate", type: "DESC" }, { name: "refStatus.seq", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitReleaseResult",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitReleaseResult" }],
                    sort: [{ name: "createDate", type: "DESC" }, { name: "refStatus.seq", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forRequestRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["draft", "reEditAuthority"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }, { name: "refStatus.seq", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forApproveRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["waitReleaseResult", "waitApprove", "waitPayment", "approve", "notApprove"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }, { name: "refStatus.seq", type: "DESC" }]
                },
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const createWhereFor = ({ props }) => {
    const { menuContext, routerPrefix, requestTypeKeys } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    whereGroup.push([{ name: "refReleaseTemp.refInspection.refUser.username", type: "String", operator: "=", value: userInfo.username }]);
    if (has({ menuContext, key: "forRequest" })) {
        const where = [];
        if (userInfo.refParent?.id) {
            where.push({ openBucket: true, name: "refReleaseTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo.id });
            where.push({ closeBucket: true, logic: "OR", name: "refReleaseTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo.refParent.id });
        } else {
            where.push({ name: "refReleaseTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo.id });
        }
        whereGroup.push(where);
    }
    if (has({ menuContext, key: "forReceive" })) {
        whereGroup.push([
            { openBucket: true, name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
            { closeBucket: true, logic: "OR", name: "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
        ]);
    }
    if (has({ menuContext, key: "forApprove" })) {
        whereGroup.push([
            { name: "refToApproveBy.username", type: "String", operator: "=", value: userInfo.username },
            { logic: "OR", name: "refReleaseTemp.refApproveResultBy.username", type: "String", operator: "=", value: userInfo.username }
        ]);
    }
    if (has({ menuContext, key: "canViewAll" })) {
        whereGroup.push([{ constant: true, name: "1", type: "String", operator: "=", value: "1" }]);
    }
    const where = [
        { name: "refRequestDoc.key", type: "String", operator: "in", value: ["24"] },
        { name: "refRequestType.key", type: "String", operator: "in", value: requestTypeKeys },
    ];
    if (["release-requests", "release-cancels", "releases"].includes(routerPrefix)) {
        where.push({ name: "refReleaseTemp.isApproveResult", type: "Boolean", operator: "=", value: true })
    }
    return [
        ...where,
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ]
};

export const createForm = () => {
    return {
        model: null,
        refModelId: null,
        refModelTempId: null,
        refRequestType: null,
        refRequestDoc: null,
        refStatus: null,
        draftCode: null,
        requestCode: null,
        refDepartment: null,
        isSignCa: null,
        refRelease: null,
        refReleaseTemp: { ...createFormRelease() },
        lastStatus: {
            draft: [{ remark: null, statusDatetime: null }],
            waitReleaseResult: [{ remark: null, statusDatetime: null }],
            forRequestRemark: [{ remark: null, statusDatetime: null }],
            forApproveRemark: [{ remark: null, statusDatetime: null }]
        }
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesResult({ props, data, refs, key }),
        ...createRulesRelease({ props, data, refs, key }),
        ...createRulesOpenInspection({ props, data, refs, key }),
        ...createRulesProduct({ props, data, refs, key }),
    }
};

export const createRulesResult = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refReleaseTemp.refResult`]: [required],
    };
    model?.refReleaseTemp?.products?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refReleaseTemp.products.${index}.refResult`] = [required];
        }
    });
    return rules;
};

export const createRulesProduct = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refReleaseTemp?.refInspection?.refInformTemp?.products?.forEach((item, index) => {
        if (item.isDelete !== true) {
            if (item.isSampling) {
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.samplingDatetime`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.refOperation`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.manufactureDate`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.manufactureExpireDate`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.manufacturer`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.importer`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.distributor`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.size`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.refSizeUnit`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.qty`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.samplings.0.refQtyUnit`] = [required];
            }
            if (item.isSequestrate) {
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.sequestrates.0.sequestrateDatetime`] = [required];
                rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.sequestrates.0.storageLocationName`] = [required];
            }
            item.productQties?.forEach((productQty, index2) => {
                if (productQty.enable) {
                    rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.qty`] = [required];
                    rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.netWeight`] = [required];
                    rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.numberOfPackage`] = [required];
                    rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.packageSize`] = [required];
                    rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.amount`] = [required];
                    if (productQty.docName === i18n.global.t("model.informProductQty.labels.releaseDoc")) {
                        if (model.refRequestType?.key !== "4") {
                            rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.qty`].push(greaterThan(0));
                            rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.netWeight`].push(greaterThan(0));
                            rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.numberOfPackage`].push(greaterThan(0));
                            rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.packageSize`].push(greaterThan(0));
                            rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.amount`].push(greaterThan(0));
                        }
                        const inspectionProductQty = productQty?.refInspectionProductQty;
                        rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.qty`].push(lessThanOrEqualTo(inspectionProductQty?.qty || 0));
                        rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.netWeight`].push(lessThanOrEqualTo(inspectionProductQty?.netWeight || 0));
                        rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.numberOfPackage`].push(lessThanOrEqualTo(inspectionProductQty?.numberOfPackage || 0));
                        rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.packageSize`].push(lessThanOrEqualTo(inspectionProductQty?.packageSize || 0));
                        // rules[`${prefix}refReleaseTemp.refInspection.refInformTemp.products.${index}.productQties.${index2}.amount`].push(lessThanOrEqualTo(inspectionProductQty?.amount || 0));
                    }
                }
            });
        }
    });
    return rules;
};

export const createRulesRelease = ({ key, data }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refReleaseTemp.releaseDate`]: [required],
        [`${prefix}refReleaseTemp.refValidateDocStatus`]: [required],
        [`${prefix}refReleaseTemp.validateDocRemark`]: [requiredWhen({ when: () => model.refReleaseTemp?.refValidateDocStatus?.key === "3" })],
        [`${prefix}refReleaseTemp.refSequestrate`]: [required],
        [`${prefix}refReleaseTemp.refOpenInspectionResult`]: [required],
        [`${prefix}refReleaseTemp.refInspectionIncorrectResult`]: [requiredWhen({ when: () => model.refReleaseTemp?.refOpenInspectionResult?.key === "2" })],
        [`${prefix}refReleaseTemp.inspectionIncorrectRemark`]: [requiredWhen({ when: () => model.refReleaseTemp?.refInspectionIncorrectResult?.key === "3" })],
    };
    model?.refReleaseTemp?.officers?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refReleaseTemp.officers.${index}.refUser`] = [required];
        }
    });
    return rules
};

export const createRulesOpenInspection = ({ props, key, data }) => {
    const { viewOnly } = props;
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    let rules = {};
    if (!viewOnly) {
        model.refReleaseTemp?.openInspections?.forEach((d, index) => {
            rules = {
                ...rules,
                [`${prefix}refReleaseTemp.openInspections.${index}.inspectionDatetime`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.refTransportByWay`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.vehicleNo`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.netWeight`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.refNetWeightUnit`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.qty`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.refQtyUnit`]: [requiredWhen({ when: () => model.refReleaseTemp?.isApproveResult && model.refReleaseTemp?.refInspection?.isInspect })],
                [`${prefix}refReleaseTemp.openInspections.${index}.qtySampling`]: [],
                [`${prefix}refReleaseTemp.openInspections.${index}.refQtySamplingUnit`]: [],
                [`${prefix}refReleaseTemp.openInspections.${index}.boxNo`]: [],
                [`${prefix}refReleaseTemp.openInspections.${index}.sealNo`]: [],
            }
        });
    }
    return rules
};

export const createFormTitle = ({ props, data }) => {
    const { routerPrefix } = props;
    const modelRef = data.useForm.modelRef;

    if (routerPrefix === "release-results") {
        return modelRef.id ? `${modelRef.refRequestDoc?.attribute?.releaseResultTitle || modelRef.refRequestDoc?.value} ${modelRef.refRelease?.approveCode || ''} (${modelRef.refReleaseTemp?.isApproveResult ? i18n.global.t('button.approve') : modelRef.refStatus?.value})` : i18n.global.t("button.create");
    } else {
        return modelRef.id ? `${modelRef.refRequestDoc?.value} ${modelRef.refRelease?.approveCode || ''} (${modelRef.refStatus?.value})` : i18n.global.t("button.create");
    }
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault, routerPrefix, viewOnly, requestTypeKeys } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callRequestStatus({}),
        callRequestType({}),
        callRequestDoc({}),
        callRequestDocGenType({}),
        callResultType({}),
        callAddressType({}),
    ];
    return Promise.all(promises).then(arr => {
        const userInfo = store.state.resource.auth.info?.user;
        data.statuses = arr[0];
        data.requestTypes = arr[1];
        data.requestDocs = arr[2];
        data.requestDocGenTypes = arr[3];
        data.resultTypes = arr[4];
        data.addressTypes = arr[5];

        if ((!id && !form) || forceDefault) {
            modelRef.isOfficerCreate = !!userInfo.refOfficerLv;
            modelRef.lastStatus.draft[0].statusDatetime = moment().format("YYYY-MM-DD[T]HH:mm:ssZ");
            modelRef.refRequestType = data.requestTypes.find(d => d.key === requestTypeKeys[0]);
            modelRef.refRequestDoc = data.requestDocs.find(d => d.key === "24");
            modelRef.refDocGenType = data.requestDocGenTypes.find(d => d.key === "1");
            if (!modelRef.isOfficerCreate) {
                callUserCompanyMe({}).then(userCompanies => {
                    const refUserCompany = userCompanies[0];
                    modelRef.refReleaseTemp.refUserCompany = refUserCompany;
                    if (refUserCompany) {
                        callUser({ userCompanyId: refUserCompany.id }).then(
                            users => {
                                modelRef.refReleaseTemp.refUser = users.find(d => d.id === userInfo?.id)
                                modelRef.refReleaseTemp.refInspector = users.find(d => d.id === userInfo?.id)
                            }
                        );
                    }
                });
            }
        }

        if (modelRef.refReleaseTemp?.id) {
            data.products = getFetchProducts({ releaseId: modelRef.refReleaseTemp?.id });
        }
        if (modelRef.refReleaseTemp?.refInspection?.refInformTemp?.id) {
            data.informProducts = getFetchInformProducts({ informId: modelRef.refReleaseTemp?.refInspection?.refInformTemp?.id });
        }
        if (["release-requests", "releases"].includes(routerPrefix) && !viewOnly) {
            if (modelRef.refReleaseTemp.officers?.length === 0) {
                modelRef.refReleaseTemp.officers?.push({ refUser: userInfo, tel: null });
            }
        }
    });
};

export const getFetchProducts = ({ releaseId }) => {
    return {
        fetchCriteria: {
            select: [
                "**",
                "refInspectionProduct.refInformProduct.**",
            ],
            page: 0,
            size: 1000000,
            where: [{ name: "refRelease.id", type: "UUID", operator: "=", value: releaseId }],
            sort: [{ name: "createDate", type: "ASC" }],
            children: [
                {
                    name: "productQties",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refInspectionProduct.productQties",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "samplingsReal",
                    asName: "samplings",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    sort: [{ name: "createDate", type: "DESC" }],
                    children: [
                        {
                            name: "distributors",
                            select: ["**"],
                            page: 0,
                            size: 1000000,
                            sort: [{ name: "createDate", type: "ASC" }],
                        },
                    ]
                },
                {
                    name: "sequestratesReal",
                    asName: "sequestrates",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    sort: [{ name: "createDate", type: "DESC" }],
                    children: [
                        {
                            name: "addresses",
                            select: ["**"],
                            page: 0,
                            size: 1,
                            sort: [{ name: "createDate", type: "DESC" }],
                        },
                    ],
                },
            ]
        }
    };
}

export const getFetchInformProducts = ({ informId }) => {
    return {
        fetchCriteria: {
            select: ["**"],
            page: 0,
            size: 1000000,
            where: [
                { name: "refInform.id", type: "UUID", operator: "=", value: informId },
                { name: "isActive", type: "Boolean", operator: "=", value: true },
            ],
            sort: [{ name: "createDate", type: "ASC" }],
            children: [
                {
                    name: "refHaz.mainSubStances",
                    select: ["*", "refSubStance.*", "refUnit.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "refHaz.distributors",
                    select: ["refDistributor.**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
            ]
        }
    };
}

export const setIsCheck = ({ modelRef, id, checked }) => {
    const product = modelRef.refReleaseTemp?.products?.find(p => p.refInformProduct?.id === id);
    if (product) {
        product.isCheck = checked;
        product.isSave = true;
        modelRef.refReleaseTemp.isSave = true;
    }
};

export const setProductQty = ({ modelRef, record, informProduct }) => {
    const releaseProduct = modelRef.refReleaseTemp?.products?.find(p => p.refInformProduct?.id === informProduct?.id && !p.isDelete);
    const releaseProductQty = releaseProduct?.productQties?.find(q => (q.id === record?.id || q.refInformProductQty?.id === record?.id) && !q.isDelete);
    if (releaseProductQty) {
        releaseProduct.isSave = true;
        releaseProduct.refInformProduct.isSave = false;
        releaseProductQty.isSave = true;
        releaseProductQty.refInformProductQty.isSave = false;
        releaseProductQty.amount = record.amount;
        releaseProductQty.netWeight = record.netWeight;
        releaseProductQty.numberOfPackage = record.numberOfPackage;
        releaseProductQty.packageSize = record.packageSize;
        releaseProductQty.qty = record.qty;
    }
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.columns = createColumns({ props });
    state.manages = [
        createManageSelect({ menuContext }),
        {
            icon: () => <CIcon file="check.svg"></CIcon>,
            text: () => i18n.global.t("button.signApprove"),
            force: true,
            visible: () => has({ menuContext, key: "forApprove" }),
            rowSelection: true,
            buttonProp: { class: "btn-success" },
            onClick: ({ rowSelection }) => {
                openModalFormConfirmApprove({
                    props,
                    onOk: record => {
                        const isStatusWaitRelease = ["waitRelease"].includes(record.refStatus?.key);
                        const forms = rowSelection.selectedRows.map(d => {
                            let form = { ...d, refStatus: record.refStatus };
                            if (record.refStatus?.key === "notApprove") {
                                form.remark = record.remark;
                            }
                            if (isStatusWaitRelease) {
                                form = {
                                    ...form,
                                    refReleaseTemp: {
                                        ...d.refReleaseTemp,
                                        isApproveResult: true,
                                        refApproveResultBy: store.state.resource.auth.info?.user,
                                    }
                                }
                            }
                            return form;
                        });
                        setIsLoading(true);
                        callRequestAll({ forms })
                            .then(() => notification["success"]({ message: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`) }))
                            .then(() => onSearch({ props, page: state.page, state }))
                            .finally(() => setIsLoading(false));
                    }
                });
            },
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canApprove({ props, record }) || record.refStatus?.key !== "waitApprove" })
        },
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canArchive({ props, record }) })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [
        createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) }),
        createManageExtraCreate({
            menuContext, onClick: () => openModalGenReleaseForm({ props }),
            visible: () => {
                let result = false;
                if (routerPrefix === "release-results" && has({ menuContext, key: "forReceive" })) {
                    result = true || result;
                }
                if (["release-requests", "releases"].includes(routerPrefix) && has({ menuContext, key: "forReceive" })) {
                    result = true || result;
                }
                return result;
            },
        })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        }),
        createRowActionReStatus({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.reStatus") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        setIsLoadingApp(true);
                        callReStatus({ data: record })
                            .finally(() => setIsLoadingApp(false))
                            .then(() => onSearch({ props, page: state.page }));
                    }
                });
            },
            visible: ({ record }) => state.conditionAction.canReStatus({ props, record })
        }),
        createRowActionPdf({
            visible: () => false,
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callReport: ({ record }) => callReportRelease({ data: { id: record.id } }),
            fileName: "report.pdf"
        }),
    ];
};

export const openModalGenReleaseForm = ({ props }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            okButtonProps: { disabled: false },
            title: i18n.global.t("views.release.genRelease"),
            width: "800px",
            onOk: () => {
                refs.form.callOnClickModalOk().then(record => {
                    setIsLoadingApp(true);
                    generateReleaseDoc({ data: { ...record.refInspection, isDto: true } })
                        .then(() => {
                            onSearch({ props, page: state.page });
                            options.bind.onCancel();
                        })
                        .finally(() => setIsLoadingApp(false))
                });
            },
        }),
        render: () => (<GenReleaseForm ref={ (e) => {if (e) refs.form = e;} }{...props}></GenReleaseForm>),
    });
    return options;
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = [
        ...createConditionFormResult({ props, data, refs, isLoading }),
        ...createConditionFormRelease({ props, data, refs, isLoading }),
        ...createConditionFormInform({ dataKey: "refReleaseTemp.refInspection" }),
    ];
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.products?.filter(d => d.isDelete !== true)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.products"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.refInspection?.refInformTemp?.products?.filter(d => d.isDelete !== true)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.refInspection.refInformTemp.products"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.refInspection?.refInformTemp?.products?.filter(d => d.isSampling)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.refInspection.refInformTemp.products"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.refInspection?.refInformTemp?.products?.filter(d => d?.isDelete !== true)?.flatMap(d => d.productQties)?.filter(d => d?.isDelete !== true)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.refInspection.refInformTemp.products"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.officers?.filter(d => d.isDelete !== true)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.officers"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refReleaseTemp?.openInspections?.filter(d => d.isDelete !== true)?.length,
        createRules: () => createRules({ props, data, refs }),
        itemsKey: "refReleaseTemp.openInspections"
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive, feeStatements } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canWaitApprove = state.conditionAction.canWaitApprove({ props, record: initialModel });
    const canAcknowledge = state.conditionAction.canAcknowledge({ props, record: initialModel });
    const canApprove = state.conditionAction.canApprove({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    const canSendNsw = state.conditionAction.canSendNsw({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButtonSave({
                onClick: () => {
                    const refReleaseTemp = modelRef.refReleaseTemp;
                    let statusRemark = null;
                    if ([undefined, "draft", "reEditAuthority", "waitReleaseResult"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forRequestRemark[0].remark;
                    } else if (["waitReceive", "waitApprove"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forApproveRemark[0].remark;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        formParams: {
                            refReleaseTemp: {
                                ...modelRef.refReleaseTemp,
                                refUserCompany: refReleaseTemp?.refUserCompany?.id ? refReleaseTemp?.refUserCompany : null,
                                refUser: refReleaseTemp?.refUser?.id ? refReleaseTemp?.refUser : null
                            },
                            statusRemark
                        }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (id && isActive && canWaitApprove) {
        const statusWaitApprove = data.statuses.find(status => status.key === "waitApprove");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmReceive({
                            props: {
                                dataProps: data,
                                roleName: routerPrefix === "release-results" ? "RELEASE_RESULT_APPROVE" : "RELEASE_APPROVE",
                                isShowDepartment: true,
                                form: modelRef,
                            },
                            onOk: record => {
                                const isStatusBack = ["reEditAuthority"].includes(record.refStatus?.key);
                                const formParams = {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forApproveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack
                                            ? modelRef.lastStatus.forApproveRemark?.[0]?.remark
                                            : null,
                                        refStatus: record.refStatus,
                                        refToApproveBy: record.refToApproveBy,
                                        refReleaseTemp: {
                                            ...modelRef.refReleaseTemp,
                                        }
                                };
                                if (routerPrefix === "release-results") {
                                    formParams.refReleaseTemp.refOfficerResult = lodash.cloneDeep(store.state.resource.auth.info?.user);
                                } else {
                                    formParams.refReleaseTemp.refOfficer = lodash.cloneDeep(store.state.resource.auth.info?.user);
                                }
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams,
                                    successText: i18n.global.t(`views.request.modal.receive.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canAcknowledge) {
        const statusApprove = data.statuses.find(status => status.key === "waitApprove");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.acknowledge")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmAcknowledge({
                            props,
                            onOk: record => {
                                const isStatusBack = ["reEditAuthority"].includes(record.refStatus?.key);
                                const refReleaseTemp = lodash.cloneDeep(modelRef.refReleaseTemp);
                                refReleaseTemp.products?.forEach(product => {
                                    if (product.samplings.filter(d => !d.isCompanyAcknowledge).length > 0) {
                                        product.isSave = true;
                                        product.samplings.forEach(d => {
                                            if (!d.isCompanyAcknowledge) {
                                                d.isCompanyAcknowledge = true;
                                                d.isSave = true;
                                            }
                                        })
                                    }
                                });
                                let formParams = {
                                    statusRemark: isStatusBack
                                        ? modelRef.lastStatus.forRequestRemark[0].remark
                                        : modelRef.lastStatus.forApproveRemark[0].remark,
                                    statusRemarkBefore: isStatusBack
                                        ? modelRef.lastStatus.forApproveRemark?.[0]?.remark
                                        : null,
                                    refStatus: record.refStatus,
                                    refReleaseTemp: {
                                        ...refReleaseTemp
                                    }
                                };
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams,
                                    successText: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canApprove) {
        const statusApprove = data.statuses.find(status => status.key === "approve");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.signApprove")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmApprove({
                            props,
                            onOk: record => {
                                const isStatusBack = ["reEditAuthority"].includes(record.refStatus?.key);
                                const isStatusWaitRelease = ["waitRelease"].includes(record.refStatus?.key);
                                let formParams = {
                                    statusRemark: isStatusBack
                                        ? modelRef.lastStatus.forRequestRemark[0].remark
                                        : modelRef.lastStatus.forApproveRemark[0].remark,
                                    statusRemarkBefore: isStatusBack
                                        ? modelRef.lastStatus.forApproveRemark?.[0]?.remark
                                        : null,
                                    refStatus: record.refStatus,
                                };
                                if (record.refStatus?.key === "notApprove") {
                                    formParams.remark = record.remark;
                                }
                                if (isStatusWaitRelease) {
                                    formParams = {
                                        ...formParams,
                                        refReleaseTemp: {
                                            ...modelRef.refReleaseTemp,
                                            isApproveResult: true,
                                            refApproveResultBy: lodash.cloneDeep(store.state.resource.auth.info?.user),
                                        }
                                    }
                                }
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams,
                                    successText: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canSendNsw) {
        col2.push(
            createButton({
                text: i18n.global.t("button.sendNsw"),
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    Modal.confirm({
                        title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.sendNsw") }),
                        autoFocusButton: "cancel",
                        content: <div>{i18n.global.t("button.sendNsw")}</div>,
                        onOk: () => {
                            if (routerPrefix === "release-results") {
                                sendNswOGAInspectionResult({ data: modelRef }).then(() => {
                                    if (viewOnly) initForm({ props, data, refs, state });
                                    else onClickView({ record: modelRef, routerPrefix });
                                });
                            } else if (routerPrefix === "release-requests") {
                                sendNswRelease({ data: modelRef }).then(() => {
                                    if (viewOnly) initForm({ props, data, refs, state });
                                    else onClickView({ record: modelRef, routerPrefix });
                                });
                            }
                        },
                    });
                }
            })
        );
    }
    if (id && routerPrefix === "release-results" && !modelRef.isNswProcess2 && modelRef.nswOgaResponseMessageType) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.nswOgaResponse")} (${modelRef.nswOgaResponseMessageType})`,
                classStyle: `m-1 ${modelRef.nswOgaResponseMessageType === "ACCEPT" ? "btn-success" : "btn-danger"}`,
                onClick: () => {
                    Modal.info({
                        title: `${i18n.global.t("button.nswOgaResponse")} (${modelRef.nswOgaResponseMessageType}) - ${modelRef.nswOgaResponseId})`,
                        autoFocusButton: "cancel",
                        width: 1200,
                        content: <pre lang="xml">{formatXml(modelRef.nswOgaResponsePayload, "   ")}</pre>,
                    });
                }
            })
        )
    }
    if (id && routerPrefix === "release-requests" && !modelRef.isNswProcess && modelRef.nswLicenseResponseMessageType) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.nswLicenseResponse")} (${modelRef.nswLicenseResponseMessageType})`,
                classStyle: `m-1 ${modelRef.nswLicenseResponseMessageType === "ACCEPT" ? "btn-success" : "btn-danger"}`,
                onClick: () => {
                    Modal.info({
                        title: `${i18n.global.t("button.nswLicenseResponse")} (${modelRef.nswLicenseResponseMessageType}) - ${modelRef.nswLicenseResponseId})`,
                        autoFocusButton: "cancel",
                        width: 1200,
                        content: <pre lang="xml">{formatXml(modelRef.nswLicenseResponsePayload, "   ")}</pre>,
                    });
                }
            })
        )
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    if (
        id &&
        feeStatements?.[0]?.id &&
        ((has({ menuContext, key: "forRequest" }) && ![undefined, "draft"].includes(feeStatements?.[0]?.refStatus?.key)) ||
            have({ menuContext, keys: ["forReceive", "forApprove"] }))
    ) {
        col2.push(
            createButton({
                text: `${i18n.global.t("model.feeStatement.modelName")}${feeStatements?.[0] ? ` (${feeStatements[0].refStatus?.value})` : ""}`,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        router.push({ name: `fees-view`, params: { id: feeStatements?.[0]?.id } });
                    });
                },
                icon: <CIcon file="active.svg"></CIcon>
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const state = reactive({
    page: createPage({
        options: {
            select: [
                "*",
                "refDepartment.*",
                "refRelease.*",
                "refRelease.refStatus.*",
                "refReleaseTemp.**",
                "refReleaseTemp.refUserCompany.*",
                "refReleaseTemp.refUserCompany.refPersonType.*",
                "refReleaseTemp.refInspection.*",
                "refReleaseTemp.refInspection.refRequestDoc.*",
                "refReleaseTemp.refInspection.refInformTemp.approveCode",
                "refReleaseTemp.refResult.*",
                "refReleaseTemp.refStatus.*",
                "refRequestType.*",
                "refStatus.*",
                "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.id",
                "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.nameTh",
                "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.fullCode",
            ],
            sort: [{ name: "updateDate", type: "DESC" }],
            children: [
                {
                    name: "refReleaseTemp.products",
                    select: ["*", "refInspectionProduct.refInformProduct.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
